import React, { Component, Suspense } from "react";
import { HashRouter, Navigate, Route, Routes, BrowserRouter as Router, BrowserRouter } from "react-router-dom";
import Loading from "./components/loading/loading";
import { InstallPWA } from "./components/installPWA/installPWA";
import ProtectedRoute from "./protectedRoute";
import ScrollToTop from "./components/scrollToTop/scrollToTop";
import "./scss/style.scss";
// Kept here rather than in AppSidebar so it lands in the main (render-blocking)
// CSS bundle instead of a lazy chunk that applies after first paint.
import "simplebar/dist/simplebar.min.css";

// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));
const Login = React.lazy(() => import("./views/login/Login"));

class App extends Component {
  token = localStorage.getItem("token");
  render() {
    return (
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<Loading style={{ height: "100vh!important" }} />}>
          <Routes>
            <Route path="/login" name="Login Page" element={<Login />} />
            <Route
              path="*"
              name="Home"
              element={
                <ProtectedRoute>
                  <DefaultLayout />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Suspense>

        <InstallPWA />
      </BrowserRouter>
    );
  }
}

export default App;
